import themeGet from '@styled-system/theme-get';
import styled, { css } from 'styled-components';

import { Link as LinkUnited } from '@olist/united';

export const BannerPrincipal = styled.section`
  background: #e9ebed;
  h1 {
    margin-bottom: 16px;
    max-width: 574px;
  }
  p {
    font-size: 18px;
    font-weight: 400;
    line-height: 150%;
    margin-bottom: 10px;
    max-width: 500px;
    ${({ theme }) => {
      return (
        theme &&
        css`
          @media (max-width: ${theme.breakpoints.medium}) {
            font-size: 16px;
          }
        `
      );
    }}
    strong {
      font-weight: normal;
      position: relative;
      z-index: 9;
      &:after {
        background: #364ef7;
        content: '';
        display: inline-block;
        height: 10px;
        left: 0;
        position: absolute;
        top: 60%;
        transition: 0.3s;
        width: 100%;
        z-index: -9;
      }
    }
  }
`;

export const Right = styled.div`
  width: 60%;
  img {
    height: 100%;
    object-fit: contain;
    width: 100%;
  }
  ${({ theme }) => {
    return (
      theme &&
      css`
        @media (max-width: ${theme.breakpoints.medium}) {
          width: 100%;
        }
      `
    );
  }}
`;

export const Left = styled.div`
  width: 40%;
  ${({ theme }) => {
    return (
      theme &&
      css`
        @media (max-width: ${theme.breakpoints.medium}) {
          width: 100%;
          padding-right: 0;
          margin-top: 0;
          margin-bottom: calc(30px / 2);
        }
      `
    );
  }}
`;

export const Container = styled.div`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 1440px;
  padding: 0 80px;
  ${({ theme }) => {
    return (
      theme &&
      css`
        @media (max-width: ${theme.breakpoints.medium}) {
          padding: 0 16px;
          flex-direction: column;
        }
      `
    );
  }}
`;

export const CasesPrincipais = styled.div`
  position: relative;
  margin: 0;
  .marca{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: auto;
    margin: 60px 90px;
    max-width: calc(100% - 180px);
    ${({ theme }) => {
      return (
        theme &&
        css`
          @media (max-width: ${theme.breakpoints.medium}) {
            max-width: 100%;
            margin: 0;
            flex-direction: column;
          }
        `
      );
    }}
  }
  .swiper-slide{
    opacity: 0;
    &.swiper-slide-active{
      opacity: 1;
    }
  }
}`;

export const Image = styled.div`
  border-radius: 15px;
  height: 0;
  margin-left: 0;
  overflow: hidden;
  padding-bottom: 100%;
  position: relative;
  width: 100%;
  z-index: 9;
  > div {
    position: static !important;
  }
  ${({ theme }) => {
    return (
      theme &&
      css`
        @media (max-width: ${theme.breakpoints.medium}) {
          width: 100%;
          margin-left: 0;
          display: block;
        }
      `
    );
  }}
  img {
    border-radius: calc(30px / 2);
    height: 100%;
    left: 0;
    object-fit: cover;
    position: absolute;
    top: 0;
    transition: 0.8s;
    transition-delay: 0.3s;
    width: 100%;
    ${({ theme }) => {
      return (
        theme &&
        css`
          @media (max-width: ${theme.breakpoints.medium}) {
            border-bottom-right-radius: 0;
            border-bottom-left-radius: 0;
          }
        `
      );
    }}
  }
  .active {
    transform: scale(1);
  }

  .disable {
    transform: scale(0.845);
  }
`;

export const Link = styled(LinkUnited)`
  background-color: #0c29d0;
  border: 1px solid #0c29d0;
  border-radius: ${themeGet('olist.borderRadius.pill')};
  color: #ffffff;
  display: flex;
  height: 48px;
  padding: 0px 24px;
  width: fit-content;
  &:hover {
    background-color: #0c29d0 !important;
    border: 1px solid #0c29d0 !important;
    box-shadow: none !important;
    color: #ffffff !important;
    svg {
      margin-left: 10px;
      width: 12px;
    }
  }
  svg {
    display: block;
    margin-left: 0px;
    overflow: hidden;
    transition: 0.3s;
    width: 0;
    path {
      fill: #ffffff !important;
    }
  }
  a {
    color: #ffffff;
    text-decoration: none;
  }
`;
